import { useTranslation } from 'react-i18next';

import type { TranslationKey } from '@/i18n-key';

import { SparklesIcon } from '@/pages/ManagerAssessment/shared/PrepareMeetingIcons';

interface AiPromptModalHeaderProps {
    titleKey: TranslationKey;
    /** Id of the title heading, so the dialog can take its accessible name from it. */
    titleId: string;
}

export const AiPromptModalHeader = ({ titleKey, titleId }: AiPromptModalHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={
                '!mb-6 flex !items-center gap-5 md:mb-10 md:!gap-10 lg:!mb-13 lg:!items-start'
            }
        >
            <div
                className={
                    'flex h-20 w-20 shrink-0 items-center justify-center rounded-lg border border-indigo-500 lg:!h-35 lg:!w-35'
                }
            >
                <SparklesIcon
                    strokeWidth={1.3}
                    className={'h-15 w-15 text-indigo-700 lg:h-20 lg:w-20'}
                />
            </div>
            <h2
                id={titleId}
                className={
                    'max-md:text-heading-sm bg-gradient-to-r from-indigo-700 to-pink-500 bg-clip-text leading-tight font-semibold text-transparent md:text-[36px]'
                }
            >
                {t(titleKey)}
            </h2>
        </div>
    );
};
